import React, { useState, useEffect, useMemo } from 'react';
import { CONTACT } from '../data/services';
import image1 from '../assets/images/DSC04252.JPG';
import image2 from '../assets/images/DSC04167.JPG';
import image3 from '../assets/images/DSC04292.JPG';

const TRUST_POINTS = [
  { icon: 'verified', text: 'ประสบการณ์กว่า 20 ปี' },
  { icon: 'medical_services', text: 'One Stop Service' },
  { icon: 'schedule', text: 'ฉุกเฉิน 24 ชม.' },
];

function Hero() {
  const images = useMemo(() => [image1, image2, image3], []);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="hero" id="home" aria-label="Pet Direct Hospital">
      {images.map((image, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}

      <div className="hero-overlay">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="dot" aria-hidden="true" />
            โรงพยาบาลสัตว์เพ็ทไดเร็ค • ทองหล่อ 20
          </div>
          <h1>
            ดูแลน้องๆ ของคุณ
            <br />
            <span>เหมือนคนในครอบครัว</span>
          </h1>
          <p>
            โรงพยาบาลสัตว์ครบวงจรใจกลางทองหล่อ ตรวจรักษา ผ่าตัด อาบน้ำ-ตัดขน
            โรงแรมสัตว์เลี้ยง และรถรับ-ส่งถึงบ้าน โดยทีมสัตวแพทย์ผู้เชี่ยวชาญ
          </p>
          <div className="hero-actions">
            <a
              href={CONTACT.lineUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button"
            >
              <span className="material-icons" aria-hidden="true">chat</span>
              จองคิวผ่าน LINE
            </a>
            <a href={CONTACT.phoneHref} className="contact-button ghost">
              <span className="material-icons" aria-hidden="true">call</span>
              โทร {CONTACT.phone}
            </a>
          </div>
          <ul className="hero-trust" aria-label="จุดเด่นของเรา">
            {TRUST_POINTS.map((point) => (
              <li key={point.text}>
                <span className="material-icons" aria-hidden="true">{point.icon}</span>
                {point.text}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="hero-dots" role="tablist" aria-label="สไลด์รูปภาพ">
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            className={index === currentIndex ? 'active' : ''}
            onClick={() => setCurrentIndex(index)}
            aria-label={`สไลด์ ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

export default Hero;
